import { useI18n } from '@change-corgi/core-react/i18n';

import { useContributionsPageState } from '#src/app/pages/accountSettings/contributions/main/pageContext';
import { validateAmount } from '#src/app/shared/utils/payments';

export function useValidate(): () => boolean {
	const [
		{
			subscription: {
				unsavedAmount,
				currencyCode,
				config: { maximumAmount, minimumAmount },
			},
		},
		{ setContributionsFormValidationErrors, clearContributionsFormLoading },
	] = useContributionsPageState();

	const { typedTranslate, localizeCurrency } = useI18n();
	return function validate() {
		setContributionsFormValidationErrors(null);
		const amountValidationI18nKey = validateAmount({
			amount: unsavedAmount,
			maximumAmount,
			minimumAmount,
		});
		if (!amountValidationI18nKey) return true;

		const localizedMinimumAmount = localizeCurrency(minimumAmount, currencyCode, {
			currencyDisplay: 'narrowSymbol',
			amountInBaseUnits: false,
		});

		const localizedMaximumAmount = localizeCurrency(maximumAmount, currencyCode, {
			currencyDisplay: 'narrowSymbol',
			amountInBaseUnits: false,
		});

		const error = {
			amount: typedTranslate(amountValidationI18nKey, {
				...(minimumAmount && { minimumAmount: localizedMinimumAmount }),
				...(maximumAmount && { maximumAmount: localizedMaximumAmount }),
			}),
		};
		setContributionsFormValidationErrors(error);
		clearContributionsFormLoading();
		return false;
	};
}
